import React from "react";
import "../../../style/components/dialogs/enable-paid-features/additional-users.module.css";

export interface AdditionalUsersConfig {
    numberOfFreeUsers: number;
}

const AdditionalUsers = ({ config }: { config: AdditionalUsersConfig }) => {
    return <div className="additional-users-container">{config.numberOfFreeUsers} free users</div>;
};

export default AdditionalUsers;
